const createPubSub = () => {
  const listeners = new Set()
  return {
    subscribe: (cb) => { listeners.add(cb) },
    unsubscribe: (cb) => listeners.delete(cb),
    publish: (data) => listeners.forEach((cb) => cb(data))
  }
}

const cartChangeEvent = createPubSub()
let cartResolver

const refresh = () => {
  cartResolver = Promise.withResolvers()
  cartChangeEvent.publish()
  fetch('/cart.js')
    .then((res) => res.json())
    .then(cartResolver.resolve)
}

const get = async () => {
  if(!cartResolver) refresh()

  return cartResolver.promise
}


// let existingCart
// try {
//   existingCart = JSON.parse(window.localStorage.getItem('md-cart'))
// } catch {}
// if(existingCart && !cartResolver) {
//   cartResolver = Promise.withResolvers()
//   cartResolver.resolve(existingCart)
// }
//
// cartChangeEvent.subscribe(async () => {
//   window.localStorage.setItem('md-cart', JSON.stringify(await get()))
// })

export default {
  get,
  refresh,
  subscribe: cartChangeEvent.subscribe,
  unsubscribe: cartChangeEvent.unsubscribe
}
